import { useMutation, gql } from "@apollo/client"
import { KNOWLEDGE_FIELDS } from "./useQueryKnowledges"

const UPDATEKNOWLEDGE_MUTATION = gql`
  mutation UpdateKnowledge($id: ID!, $title: String!, $category: ID!, $groups: [ID!], $locations: [ID!], $content: [KnowledgeContentInput!]!) {
    updateKnowledge(id: $id, title: $title, category: $category, groups: $groups, locations: $locations, content: $content) {
      ${KNOWLEDGE_FIELDS}
    } 
  }
`

const useMutationUpdateKnowledge = () => useMutation(UPDATEKNOWLEDGE_MUTATION)

export { useMutationUpdateKnowledge }
